// extracted by mini-css-extract-plugin
export default {"eventDetailShareCard":"EventDetails_eventDetailShareCard__STu+S","eventDetailShare":"EventDetails_eventDetailShare__jz3BQ"};